import { render, staticRenderFns } from "./SDKList.vue?vue&type=template&id=4b3954b8&"
import script from "./SDKList.vue?vue&type=script&lang=js&"
export * from "./SDKList.vue?vue&type=script&lang=js&"
import style0 from "./SDKList.vue?vue&type=style&index=0&id=4b3954b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports